import Banner from "./components/banner/Banner";
import CardCarousel from "./components/card-carousel/CardCarousel";
import Section from "./components/section/Section";
import Card from "./components/card/Card";
import Testimonial from "./components/testimonial/Testimonial";
import Hero from "./components/hero/Hero";
import TeamMembers from "./components/team-members/TeamMembers";
import SlideShow from "./components/slide-show/SlideShow";
import Tabular from "./components/tabular/Tabular";
import AcademicCalendar from "./components/academic-calendar/AcademicCalendar";
import Grid from "./components/grid/Grid";
import Gallery from "./components/gallery/Gallery";
import GoogleForm from "./components/google-form/GoogleForm";
import StandardText from "./components/standard-text/StandardText";
import DynamicTabular from "./components/dynamic-tabular/DynamicTabular";
import LinkedSectionContainer from "./components/linked-sections/LinkedSectionContainer";
import LinkedSection from "./components/linked-sections/LinkedSection";
import WeeklyCalendar from "./components/tutor-components/weekly-calendar/WeeklyCalendar";
import GenericContainer from "./components/generic-container/GenericContainer";
import GenericSection from "./components/generic-container/GenericSection"
import LoginForm from "./components/login-form/LoginForm";
import BubbleCard from "./components/bubble/BubbleCard";
import PDFViewer from "./components/pdf-viewer/PDFViewer";

const componentMapping = {
    Banner,
    CardCarousel,
    Section,
    Card,
    Testimonial,
    Hero,
    TeamMembers,
    SlideShow,
    Tabular,
    AcademicCalendar,
    Grid,
    Gallery,
    GoogleForm,
    StandardText,
    DynamicTabular,
    LinkedSectionContainer,
    LinkedSection,
    WeeklyCalendar,
    GenericContainer,
    GenericSection,
    LoginForm,
    BubbleCard,
    PDFViewer
  };
  
  export default componentMapping;